import { ThemeUIProvider, useThemeUI } from 'theme-ui'
import { Global } from '@emotion/react'

import { globalStyles as defaultGlobalStyles } from 'src/theme/adSales/styles'
import { adSales } from 'src/theme/adSales'

import type { WithChildren } from 'src/types/utils'
import type { Theme as ThemeUI, ThemeUIContextValue } from 'theme-ui'

interface AdSalesCtxValue extends Omit<ThemeUIContextValue, 'theme'> {
  theme: typeof adSales
}

export const Theme = ({ children }: WithChildren<{ theme?: ThemeUI }>) => (
  <ThemeUIProvider theme={adSales}>{children}</ThemeUIProvider>
)

export const GlobalStyles = ({ styles = defaultGlobalStyles }) => <Global styles={styles} />
export const useTheme = useThemeUI as unknown as () => AdSalesCtxValue
